<template>
<div class="chapter">
<div class="inner_page">
<h1>Content</h1>
<ol>
<li><a href="#/Text/Section0003">Prisoner of the Brain-Mistress</a></li>
<li><span href="#/Text/Section0004" title="Link target outside of Sample">The Ultimate World</span></li>
<li><span href="#/Text/Section0005" title="Link target outside of Sample">Mary Anonymous</span></li>
<li><span href="#/Text/Section0006" title="Link target outside of Sample">Savage Galahad</span></li>
<li><span href="#/Text/Section0007" title="Link target outside of Sample">In His Image</span></li>
<li><span href="#/Text/Section0008" title="Link target outside of Sample">The Last Laugh</span></li>
<li><span href="#/Text/Section0009" title="Link target outside of Sample">Martian Nightmare</span></li>
<li><span href="#/Text/Section0010" title="Link target outside of Sample">Last Call</span></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?268cd212